// extracted by mini-css-extract-plugin
module.exports = {"container":"Gf","hero":"Hf","content":"If","typeProd":"Jf","notTransparent":"Kf","sliderDots":"Lf","active":"Mf"};